import { isFinanceProject, isGlobalProject } from 'config';
import { formatToDate } from 'helpers';
import { TFunc } from 'libs/i18n';
import { ClientMainInfoType } from 'modules/client/client/types';
import { CountryRiskField } from 'modules/client/common/feature';

const getClientInfoForFinance = (
  mainInfo: ClientMainInfoType | undefined,
  t: TFunc
) => {
  if (!mainInfo) {
    return undefined;
  }

  return [
    [
      {
        label: t('client.client.mainInfo.email'),
        value: mainInfo.email,
      },
      {
        label: t('client.client.mainInfo.phone'),
        value: mainInfo.phone,
      },
      {
        label: t('client.client.mainInfo.country'),
        value: mainInfo.country?.name,
        countryRisk: {
          country: mainInfo.country,
          field: CountryRiskField.RegistrationAddress,
        },
      },
    ],
    [
      {
        label: t('client.client.mainInfo.tariff'),
        value: mainInfo.tariff,
      },
      {
        label: t('client.client.mainInfo.contractNumber'),
        value: mainInfo.contractNumber,
      },
      {
        label: t('client.client.mainInfo.contractDate'),
        value: mainInfo.contractDate && formatToDate(mainInfo.contractDate),
      },
    ],
    [
      {
        label: t('client.client.mainInfo.accountNumber'),
        value: mainInfo.accountNumber,
      },
      {
        label: t('client.client.mainInfo.accountOpeningDate'),
        value:
          mainInfo.accountOpeningDate &&
          formatToDate(mainInfo.accountOpeningDate),
      },
      {
        label: t('client.client.mainInfo.centralDepositoryAccountNumber'),
        value: mainInfo.centralDepositoryAccountNumber,
      },
    ],
    [
      {
        label: t('client.client.mainInfo.centralDepositoryAccountOpeningDate'),
        value:
          mainInfo.centralDepositoryAccountOpeningDate &&
          formatToDate(mainInfo.centralDepositoryAccountOpeningDate),
      },
      {
        label: t('client.client.mainInfo.code'),
        value: mainInfo.code,
      },
    ],
  ];
};

const getClientInfoForGlobal = (
  mainInfo: ClientMainInfoType | undefined,
  t: TFunc
) => {
  if (!mainInfo) {
    return undefined;
  }

  return [
    [
      {
        label: t('client.client.mainInfo.citizenship'),
        value: mainInfo.citizenship?.name,
        countryRisk: {
          country: mainInfo.citizenship,
          field: CountryRiskField.Citizenship,
        },
      },
      {
        label: t('client.client.mainInfo.email'),
        value: mainInfo.email,
      },
      {
        label: t('client.client.mainInfo.phone'),
        value: mainInfo.phone,
      },
    ],
    [
      {
        label: t('client.client.mainInfo.country'),
        value: mainInfo.country?.name,
        countryRisk: {
          country: mainInfo.country,
          field: CountryRiskField.ResidentialAddress,
        },
      },
      {
        label: t('client.client.mainInfo.tariff'),
        value: mainInfo.tariff,
      },
      {
        label: t('client.client.mainInfo.contractNumber'),
        value: mainInfo.contractNumber,
      },
    ],
    [
      {
        label: t('client.client.mainInfo.contractDate'),
        value: mainInfo.contractDate && formatToDate(mainInfo.contractDate),
      },
      {
        label: t('client.client.mainInfo.accountNumber'),
        value: mainInfo.accountNumber,
      },
      {
        label: t('client.client.mainInfo.accountOpeningDate'),
        value:
          mainInfo.accountOpeningDate &&
          formatToDate(mainInfo.accountOpeningDate),
      },
    ],
    [
      {
        label: t('client.client.mainInfo.centralDepositoryAccountNumber'),
        value: mainInfo.centralDepositoryAccountNumber,
      },
      {
        label: t('client.client.mainInfo.centralDepositoryAccountOpeningDate'),
        value:
          mainInfo.centralDepositoryAccountOpeningDate &&
          formatToDate(mainInfo.centralDepositoryAccountOpeningDate),
      },
      {
        label: t('client.client.mainInfo.code'),
        value: mainInfo.code,
      },
    ],
  ];
};

export const getClientInfo = (
  mainInfo: ClientMainInfoType | undefined,
  t: TFunc
) => {
  if (isFinanceProject()) {
    return getClientInfoForFinance(mainInfo, t);
  }
  if (isGlobalProject()) {
    return getClientInfoForGlobal(mainInfo, t);
  }
  return undefined;
};
